/** @jsx builderX.jsx */
import { builderX, Sprite, Image } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite name='background'>
    <Sprite name='base'>
        <Sprite name='bgContainer'>
            <Image name='bg' src='bg'/>
            <Sprite name='animationContainer'/>
        </Sprite>
        <Image position={[371, 210]} name='frame' src='reelframe'/>
    </Sprite>
    <Sprite name='freespins'>
        <Sprite name='bgContainer'>
            <Image name='bg' src='bg_fg'/>
            <Sprite name='animationContainer'/>
        </Sprite>
        <Image position={[371, 210]} name='frame' src='reelframe'/>
    </Sprite>
</Sprite>;
